<template>
  <div>
    <v-card>
      <v-card-title
        class="grey lighten-4 py-4 title"
      >
        Select Shifting Crew
        <v-spacer></v-spacer>
      </v-card-title>
      <v-container grid-list-sm class="pa-4">
        <v-layout align-center row wrap>

          <v-flex v-if="servicesList.length > 0 && caseManagersList.length > 0">
            <v-checkbox v-model="isPreplan" label="Preplan"></v-checkbox>

            <v-flex xs12 align-center justify-space-between>
              <v-select
                :items="filterCaseManagers(servicesList)"
                v-model="selectedCaseManager.id"
                label="Select case manager"
              >
                <template slot="item" slot-scope="props">
                  {{ props.item.name }} - {{ props.item.description }}
                </template>
                <template slot="selection" slot-scope="props">
                  {{ props.item.name }} - {{ props.item.description }}
                </template>
              </v-select>
            </v-flex>

            <v-flex xs12 align-center justify-space-between>
              <v-select
                :disabled="isPreplan"
                :items="filterPalBearers(servicesList)"
                v-model="selectedPalbearers"
                item-text="description"
                v-on:input="limiter"
                attach
                chips
                multiple
                label="Select shifting crew"
              >
                <template slot="item" slot-scope="props">
                  {{ props.item.name }} - {{ props.item.description }}
                </template>
                <template slot="selection" slot-scope="props">
                  <span class="v-chip v-chip--select-multi theme--light">
                    <span class="v-chip__content">
                      {{ props.item.name }} - {{ props.item.description }}
                    </span>
                  </span>
                </template>
              </v-select>
            </v-flex>
            <v-snackbar
              v-model="snackbar"
              color="#ff5353"
              multi-line
              top
              right
              :timeout=6000
            >
              You can select no more than three
              <v-btn
                dark
                flat
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </v-snackbar>

          </v-flex>
          <v-flex v-else>Loading...</v-flex>

          <v-flex xs12 align-center justify-space-between>
          </v-flex>

          <v-flex md6 xs12 align-left justify-space-between>
            <v-menu
              v-model="menuDateStart"
            >
              <v-text-field
                v-model="dateStart"
                slot="activator"
                label="Select date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="dateStart" reactive></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex md6 xs12 align-center justify-space-between>
            <v-text-field
              label="Time"
              prepend-icon="alarm"
              value="12:30:00"
              v-model="timeStart"
              type="time"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 align-center justify-space-between>
            <v-textarea outline v-model="venueDescription" label="Details about the upcoming venue"></v-textarea>
          </v-flex>

        </v-layout>
      </v-container>
      <v-card-actions>
        <v-btn block color="primary" @click="saveNew" :loading="loading.saveNewBtn">Notify staff</v-btn>
      </v-card-actions>
    </v-card>

    <AppMainDialog :open="dialogOpen" :message="dialogMessage" @closedialog="dialogOpen = false"></AppMainDialog>
  </div>
</template>

<script>
  import schedulesAPI from '@/api/resources/schedules'
  import casesAPI from '@/api/resources/cases'
  import itemTypesMixins from '@/mixins/ItemTypes'
  import addButtonMixins from '@/mixins/AddButton'
  import bookingsMixins from '@/mixins/Bookings'
  import AppMainDialog from '@/components/AppMainDialog'
  import IsMobile from '@/mixins/IsMobile'
  import moment from 'moment'
  import { mapGetters } from 'vuex'

  var currentDate = new Date().toISOString().split('T')[0]

  export default {
    components: { AppMainDialog },
    mixins: [ addButtonMixins, itemTypesMixins, bookingsMixins, IsMobile ],
    data () {
      return {
        isPreplan: false,
        dialogOpen: false,
        dialogMessage: '',
        casesList: [],
        inventoriesList: [],
        servicesList: [],
        caseManagersList: [],
        selectedPalbearers: [],
        selectedService: { id: 0 },
        selectedCaseManager: { id: 0 },
        selectedCase: { id: null },
        amount: { number: 0 },
        dateStart: currentDate,
        timeStart: null,
        editableLeadId: null,
        menuDateStart: false,
        menuDateEnd: false,
        menuTimeStart: { state: false },
        menuTimeEnd: { state: false },
        venueDescription: null,
        selectedItemType: { id: this.inventoryTypeID },
        loading: {
          saveNewBtn: false
        },
        snackbar: false,
        isMobile: false
      }
    },
    watch: {
      timeStart (newVal) {
        this.checkIfMinutesSelectedAndCloseTimePopup(newVal, this.menuTimeStart)
      },
      date (newVal) {
        this.setDates(newVal)
      },
      time (newVal) {
        this.setTimes(newVal)
      },
      isPreplan (v) {
        if (v !== this.caseById(this.caseId).is_preplan) this.$store.dispatch('updateCase', {case_id: this.caseId, payload: { is_preplan: this.isPreplan }})
        if (v) this.selectedPalbearers = []
      }
    },
    computed: {
      ...mapGetters({
        caseById: 'getCaseById',
        usersList: 'allUsersRaw'
      }),
      itemId () {
        return this.itemTypeToItemIDMap[this.selectedItemType.id].id
      },
      dateStartString () {
        return this.dateStart + ' ' + (this.timeStart === null ? '00:00:00' : moment(this.timeStart, 'hh:mm A').format('HH:mm'))
      }
    },
    methods: {
      limiter (e) {
        if (e.length > 999) {
          this.snackbar = true
          e.pop()
        }
      },
      setDates (date) {
        this.dateStart = date
      },
      setTimes (time) {
        this.timeStart = time
      },
      checkIfMinutesSelectedAndCloseTimePopup (timeStr, timePopupModel) {
        if (timeStr.indexOf(':') !== -1) {
          timePopupModel.state = false
        }
      },
      saveNew () {
        let payload = {
          cases_id: this.caseId,
          is_preplan: this.isPreplan,
          is_closing: 0
        }

        this.loading.saveNewBtn = true

        if (this.editable) {
          schedulesAPI.updateLead(this.editableLeadId, this.selectedCaseManager.id, this.selectedPalbearers, this.venueDescription).then(() => {
            schedulesAPI.updatePallbearers(this.editableLeadId, this.selectedPalbearers, 0).then(() => {
              this.loading.saveNewBtn = false
            })
          }, () => {
            this.loading.saveNewBtn = false
          })
        } else {
          payload.cases_id = this.caseId
          // cases_id: this.selectedCase.id,
          payload.leads_id = this.$uuid.v4()
          payload.schedule_start = this.dateStartString

          // if selectedCase == null then this is lead saving; else this is booking saving
          if (this.selectedCase.id === null) {
            // book pallbearers with casemanager
            payload.item_id = this.selectedCaseManager.id
            payload.pallbearers_ids = this.selectedPalbearers
            payload.item_type = this.serviceTypeID
            payload.venue_description = this.venueDescription
            payload.amount = 1

            schedulesAPI.saveSchedule(payload).then(() => {
              schedulesAPI.updatePallbearers(payload.leads_id, payload.pallbearers_ids, 0).then(() => {
                delete payload.venue_description
                this.saveNewSuccess()
                this.loading.saveNewBtn = false
                this.$router.push({ name: 'NewLeadTable', params: { alert: true } })
              })
            }, this.saveNewError)
          } else {
            payload.item_id = this.itemId
            payload.item_type = this.selectedItemType.id
            payload.amount = this.amount.number

            schedulesAPI.saveSchedule(payload).then(() => {
              schedulesAPI.updatePallbearers(payload.leads_id, this.selectedPalbearers, 0).then(() => {
                this.loading.saveNewBtn = false
                this.saveNewSuccess()
                this.$router.push({ name: 'NewLeadTable', params: { alert: true } })
              })
            }, this.saveNewError)
          }
        }
      },
      filterCaseManagers (value) {
        return value.filter(service => service.hasOwnProperty('description') && service.description !== null
          ? service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casemanager' &&
            this.caseManagersList.filter(i => i.id === service.users_id).length > 0
          : false
        )
      },
      filterPalBearers (value) {
        return value.filter(service => service.hasOwnProperty('description') && service.description !== null
          ? service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casecrew' &&
            this.usersList.filter(i => i.id === service.users_id).length > 0 && this.usersList.find(i => i.id === service.users_id).roles.length > 0 && this.usersList.find(i => i.id === service.users_id).roles.filter(r => r.name === 'case-crew').length > 0
          : false
        )
      }
    },
    filters: {
      filterCaseManagers (value) {
        return value.filter(service => service.hasOwnProperty('description') && service.description !== null
          ? service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casemanager'
          : false
        )
      },
      filterPalBearers (value) {
        return value.filter(service => service.hasOwnProperty('description') && service.description !== null
          ? service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casecrew'
          : false
        )
      }
    },
    created () {
//      if (!this.date && !this.editable) {
//        this.$router.push({ name: 'AddLeadForm' })
//      }
      if (!this.$can('view', 'vendor') && this.$store.state.users.allUsers.length === 0) this.$store.dispatch('getAllUsers')
      if (this.editable && this.caseId) {
        this.isPreplan = this.caseById(this.caseId).is_preplan
        casesAPI.getLead(this.caseId).then(result => {
          // let caseCrew = result.filter(filtering => filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casecrew').map(mapping => mapping.service.id)

          let caseManagers = result.filter(filtering => filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casemanager')
          let caseManagerId = caseManagers.map(mapping => mapping.service.id)[0]

          this.dateStart = moment(result[0].schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
          this.timeStart = moment(result[0].schedule_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')

          this.selectedPalbearers = result.filter((value, index, arr) => value.item_id !== caseManagerId).map(item => { return item.item_id })
          this.selectedCaseManager.id = caseManagerId
          this.editableLeadId = caseManagers.map(mapping => mapping.leads_id)[0]

          this.venueDescription = caseManagers.map(mapping => mapping.venue_description)[0]
        }, () => {})
      } else {
        this.setDates(this.date)
        this.setTimes(this.time)
      }
    },
    mounted () {
      if (this.DetectMobile()) {
        this.isMobile = true
      }
    },
    props: {
      date: {
        type: String
      },
      time: {
        type: String
      },
      caseId: {
        type: Number
      },
      editable: {
        type: Boolean,
        required: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AddLeadFormOld.vue?7c94eec2